/**
 * "Get Notified When Available" click delegation for the Native Interactive Site Map listing
 * panel.
 *
 * Event delegation over the panel root — the Coming Soon panel content (including this button)
 * is re-rendered via innerHTML swaps on every chip/tab/lot change, so the listener binds once on
 * the stable panel container instead of being re-attached per render. Pure DOM — no Redux, no
 * CSS, no business logic. Mirrors the delegation style of handlers/cardHoverInteractionHandlers.js.
 *
 * @module nativeInteractiveSiteMap/handlers/getNotifiedInteractionHandlers
 */

const GET_NOTIFIED_BUTTON_SELECTOR = '[data-get-notified-button]';

/**
 * @returns {{ bind: Function, unbind: Function }}
 */
function createGetNotifiedInteractionHandlers() {
  const state = {
    rootElement: null,
    clickHandler: null,
  };

  function unbind() {
    if (state.rootElement && state.clickHandler) {
      state.rootElement.removeEventListener('click', state.clickHandler);
    }
    state.rootElement = null;
    state.clickHandler = null;
  }

  /**
   * @param {HTMLElement} rootElement - the stable panel container to delegate from
   * @param {() => void} onNotifyWhenAvailableClicked
   */
  function bind(rootElement, onNotifyWhenAvailableClicked) {
    unbind();
    state.rootElement = rootElement;
    state.clickHandler = (event) => {
      if (event.target instanceof Element && event.target.closest(GET_NOTIFIED_BUTTON_SELECTOR)) {
        onNotifyWhenAvailableClicked();
      }
    };
    rootElement.addEventListener('click', state.clickHandler);
  }

  return { bind, unbind };
}

export default createGetNotifiedInteractionHandlers;
